<script lang="ts">
  export let word: string
</script>

<h2>{word}</h2>

<p>
  Texte pour la questions 4 <span style="text-transform: uppercase">{word}</span>?
</p>